import React from "react";
import Grid from "@mui/material/Grid2";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import profile from "../../assets/images/jack_profile.png";
import etlBg from "../../assets/images/etl_bg.png";

const PREFIX = "TechLogBookFeatures";

const classes = {
  profile: `${PREFIX}-profile`,
  contentBox: `${PREFIX}-contentBox`,
  wrapper: `${PREFIX}-wrapper`,
  techLogTitle: `${PREFIX}-techLogTitle`,
  techlogContent: `${PREFIX}-techlogContent`,
};

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`& .${classes.techLogTitle}`]: {
    color: "white",
    fontFamily: "AvenirLTStd-Roman",
    marginBottom: "1rem",
    fontSize: 24,
    textAlign: "left",
  },
  [`& .${classes.techlogContent}`]: {
    fontSize: 20,
    fontWeight: 100,
    textAlign: "left",
    width: "80%",
    color: "white",
    marginBottom: "2rem",
    fontFamily: "AvenirLTStd-Book",
  },
  [`&.${classes.wrapper}`]: {
    backgroundImage: `url(${etlBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(4),
    flexDirection: "column",
    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
    },
  },
  [`& .${classes.profile}`]: {
    width: "100%",
    maxWidth: "350px",
    height: "350px",
    objectFit: "cover",
    borderRadius: "50%",
    border: "2px solid black",
    backgroundColor: "white",
    display: "block",
    margin: "0 auto",
    padding: 0,
    boxSizing: "border-box",
  },
  [`& .${classes.contentBox}`]: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    // padding: "2%",
    [theme.breakpoints.up("md")]: {
      paddingLeft: theme.spacing(6),
    },
  },
}));

const ProfileComponent = ({ smsPage }) => {
  return (
    <StyledGrid container className={classes.wrapper}>
      {smsPage ? (
        <Grid size={{ xs: 12, md: 8 }} className={classes.contentBox}>
          <Typography className={classes.techlogContent} gutterBottom>
            "We’ve designed our SMS to solve these challenges, putting the needs
            of real users at the heart of every decision.
          </Typography>
          <Typography className={classes.techlogContent} gutterBottom>
            "An effective SMS should let users focus on improving safety not
            leave them wrestling with clunky software.”
          </Typography>
          <Typography className={classes.techlogContent}>
            Jack Clancy, Lead Product Designer
          </Typography>
        </Grid>
      ) : (
        <Grid size={{ xs: 12, md: 8 }} className={classes.contentBox}>
          <Typography className={classes.techLogTitle} gutterBottom>
            A Simple Alternative to Outdated & Complex Systems
          </Typography>
          <Typography className={classes.techlogContent} gutterBottom>
            "An effective SMS should let users focus on improving safety not
            leave them wrestling with clunky software"
          </Typography>
          <Typography className={classes.techlogContent}>
            Jack Clancy, Lead Product Designer
          </Typography>
        </Grid>
      )}
      <Grid size={{ xs: 12, md: 4 }} className={classes.profileContainer}>
        <img
          alt="Electronic Tech Log"
          className={classes.profile}
          src={profile}
        />
      </Grid>
    </StyledGrid>
  );
};

export default ProfileComponent;
